module.exports = __webpack_public_path__ + "media/svg-new/ic-link-aa9e676a.svg";